import { render, staticRenderFns } from "./b2b_instructions.vue?vue&type=template&id=adfaa270&scoped=true&"
import script from "./b2b_instructions.vue?vue&type=script&lang=js&"
export * from "./b2b_instructions.vue?vue&type=script&lang=js&"
import style0 from "./b2b_instructions.vue?vue&type=style&index=0&id=adfaa270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfaa270",
  null
  
)

export default component.exports